<template>
  <div class="dashboard__view settings-view">
    <div class="list content-window">
      <div class="tab settings-tab">
        <div>
          <router-link
            class="tab__item--nav"
            tag="div"
            to="/dashboard/settings/profile"
            :class="state.subTabName === '' ? 'active' : ''"
            @click.native="() => (state.subTabName = '')"
            exact
          >
            Profile
          </router-link>
          <!-- <router-link class="tab__item--nav" tag="div" to="/dashboard/settings/business">Business Info</router-link> -->
          <!-- <router-link class="tab__item--nav" tag="div" to="/dashboard/settings/bankaccount">Bank Account</router-link> -->
          <!-- <router-link class="tab__item--nav" tag="div" to="/dashboard/settings/apikeys">API Keys</router-link> -->
          <!-- <router-link class="tab__item--nav" tag="div" to="/dashboard/settings/preference">Preference</router-link> -->
          <div
            class="nav-customise"
            :class="state.subTabName === 'configuration' ? 'active' : ''"
            @click="() => handleTabChange('/dashboard/settings/fee')"
            exact
          >
            Configuration
          </div>
          <router-link
            class="tab__item--nav"
            tag="div"
            to="/dashboard/settings/password"
            @click.native="() => (state.subTabName = 'password')"
            :class="state.subTabName === 'password' ? 'active' : ''"
          >
            Change Password
          </router-link>
          <router-link
            class="tab__item--nav"
            tag="div"
            to="/dashboard/settings/directdebit"
            @click.native="() => (state.subTabName = 'directdebit')"
            :class="state.subTabName === 'directdebit' ? 'active' : ''"
            >Direct Debit</router-link
          >
        </div>
        <div v-if="state.subTabName === 'configuration'" class="sub-nav">
          <div class="flex">
            <router-link
              class="tab__item--nav margin-left"
              tag="div"
              to="/dashboard/settings/fee"
              exact
              >Fee</router-link
            >
            <router-link
              class="tab__item--nav margin-left"
              tag="div"
              to="/dashboard/settings/routingrules/default"
              exact
              >vNUBAN</router-link
            >
            <router-link
                class="tab__item--nav margin-left"
                tag="div"
                to="/dashboard/settings/routingrules"
                exact
            >Routing Rules</router-link
            >
            <router-link
                class="tab__item--nav margin-left"
                tag="div"
                to="/dashboard/settings/priority-config"
                exact
            >Priority</router-link
            >
          </div>

          <Button
            buttonName="Add Fee"
            :onClick="handleRedirectCreateFee"
            classes="primary add-fee"
            v-if="$route.name === 'settings-fee'"
          >
            <template>
              <svg
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 1V11"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1 6H11"
                  stroke="white"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </template>
          </Button>
        </div>
      </div>

      <div class="tab__content">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, onBeforeMount, computed, watch } from "@vue/composition-api";
import Button from "@/components/button.vue";
export default {
  components: { Button },
  setup(props, { root }) {
    const route = root.$route;
    const state = reactive({
      subTabName: "",
    });
    onBeforeMount(() => {
      if (
        [
          "/dashboard/settings/fee",
          "/dashboard/settings/routingrules/default",
          "/dashboard/settings/routingrules",
          "/dashboard/settings/priority-config",
        ].includes(route.path)
      ) {
        state.subTabName = "configuration";
      } else {
        state.subTabName = "";
      }
    });
    watch(
      () => root.$route.path,
      (val) => {
        if (val === "/dashboard/settings/profile") {
          state.subTabName = "";
        }
      }
    );
    const handleTabChange = (route) => {
      root.$router.push(route);
      state.subTabName = "configuration";
    };
    const handleRedirectCreateFee = () =>
      root.$router.push({ name: "settings-fee-add" });
    return {
      state,
      handleTabChange,
      handleRedirectCreateFee,
    };
  },
};
</script>

<style lang="scss">
.settings-view {
  .flex {
    display: flex;
    justify-content: center;
  }
  .add-fee {
    position: absolute;
    right: 30px;
    width: 133px;
    height: 52px;
    top: 0;

    svg {
      margin-right: 10px;
    }
  }
  .sub-nav {
    display: flex;
    margin: 0px auto;
    justify-content: center;
    width: calc(100%);
    position: relative;
  }
  .settings-tab {
    display: flex;
    flex-direction: column;
    padding-top: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
    border: none !important;
    > div {
      display: flex;
      padding-top: 32px;
      padding-left: 40px;
      border: none !important;
      padding-right: 32px;
    }
    > div:first-child {
      border-bottom: 1px solid #ebf0f4;
    }
    .nav-customise {
      cursor: pointer;
      margin-right: 24px;
      color: rgba(50, 63, 75, 0.5);
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
    }
    .active {
      border-bottom: 1px solid #261940;
      // text-decoration: underline;
      color: #261940;
    }
  }
  .profile {
    border-top: none !important;
    padding: 48px 40px;
  }
  .underline {
    text-decoration: underline;
  }
  .margin-left {
    margin-right: 24px;
  }
  .content-window {
    width: fit-content;
    border: none !important;
    min-width: 100%;
  }
  .tab__item--nav {
    margin-right: 24px;
    padding: 0;
    color: rgba(50, 63, 75, 0.5);
    cursor: pointer;
  }
  .router-link-exact-active {
    color: #000;
  }
  .tab__content {
    margin-top: 55px;
  }
}
</style>
